import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import {
	makeStyles, Paper,
} from '@material-ui/core';
import useFirebase, { useFirestoreDocRT } from '../hooks/firebase';
import AdminHeader from './AdminHeader';
import AdminTeams from '../components/AdminTeams';
import AdminDonations from '../components/AdminDonations';
import AdminBoards from '../components/AdminBoards';

const useStyles = makeStyles((theme) => ({
	root: {
		paddingBottom: theme.spacing(3),
	},
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		padding: theme.spacing(1),
	},
	listCard: {
		margin: theme.spacing(1),
		maxHeight: '60vh',
		overflowY: 'scroll',
	},
	card: {
		margin: theme.spacing(1),
	},
}));

export function useIsAdmin() {
	const { currentUser } = useFirebase();
	const { uid } = currentUser || {};

	const user = useFirestoreDocRT(`users/${uid}`) || {};
	return user.isAdmin;
}

export default function Admin(props) {
	const { className } = props;
	const classes = useStyles();

	const isAdmin = useIsAdmin();
	const { currentUser } = useFirebase();

	return (
		<div className={clsx(classes.root, className)}>
			<AdminHeader />
			<div className={classes.wrapper}>
				{!isAdmin ? (
					<Paper>
						<div>Insufficiant Permissions</div>
						{ currentUser && (
							<div>{`uid: ${currentUser?.uid}`}</div>
						)}
					</Paper>
				) : (
					<>
						<Paper className={classes.listCard}>
							<AdminTeams />
						</Paper>
						<Paper className={classes.listCard}>
							<AdminDonations />
						</Paper>
						<Paper className={classes.card}>
							<AdminBoards />
						</Paper>
					</>
				)}
			</div>
		</div>

	);
}

Admin.defaultProps = {
	className: undefined,
};

Admin.propTypes = {
	className: propTypes.string,
};
